import { shaderMaterial } from "@react-three/drei";
import fragmentShader from "../shader/fresnel_frag.glsl";
import vertexShader from "../shader/fresnel_vert.glsl";

import { extend } from "@react-three/fiber";
import { Color } from "three";

export const FresnelMaterialImpl = shaderMaterial(
  {
    uBaseColor: new Color("#ff0000"),
    uFresnelColor: new Color("#0000ff"),
    uFresnelPower: 1,
    opacity: 1,
  },
  vertexShader,
  fragmentShader,
);

extend({ FresnelMaterialImpl });

const FresnelMaterial = ({
  uBaseColor = new Color("#ff0000"),
  uFresnelColor = new Color("#0000ff"),
  uFresnelPower = 1,
  ...props
}) => {
  return (
    <fresnelMaterialImpl
      {...props}
      attach="material"
      uBaseColor={uBaseColor}
      uFresnelColor={uFresnelColor}
      uFresnelPower={uFresnelPower}
    />
  );
};

export default FresnelMaterial;
